import { render, staticRenderFns } from "./consulta-solicitudes.vue?vue&type=template&id=95d80254&scoped=true&"
import script from "./consulta-solicitudes.component.ts?vue&type=script&lang=ts&"
export * from "./consulta-solicitudes.component.ts?vue&type=script&lang=ts&"
import style0 from "./consulta-solicitudes.vue?vue&type=style&index=0&id=95d80254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d80254",
  null
  
)

export default component.exports